/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuditEventSource } from './AuditEventSource';
import {
    AuditEventSourceFromJSON,
    AuditEventSourceFromJSONTyped,
    AuditEventSourceToJSON,
    AuditEventSourceToJSONTyped,
} from './AuditEventSource';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

/**
 * 
 * @export
 * @interface AuditEventResponse
 */
export interface AuditEventResponse {
    /**
     * 
     * @type {any}
     * @memberof AuditEventResponse
     */
    auditEventId?: any | null;
    /**
     * 
     * @type {AuditEventSource}
     * @memberof AuditEventResponse
     */
    source?: AuditEventSource;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    graphEventId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AuditEventResponse
     */
    eventDateTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    activity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    result?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    resultReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    initiatedById?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    initiatedByDisplayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    initiatedByUpn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    targetId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    targetDisplayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    targetUpn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    ipAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    correlationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    locationCountryOrRegion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    rawJson?: string | null;
    /**
     * 
     * @type {UserType}
     * @memberof AuditEventResponse
     */
    targetUserType?: UserType;
    /**
     * 
     * @type {string}
     * @memberof AuditEventResponse
     */
    targetInternalUserId?: string | null;
}



/**
 * Check if a given object implements the AuditEventResponse interface.
 */
export function instanceOfAuditEventResponse(value: object): value is AuditEventResponse {
    return true;
}

export function AuditEventResponseFromJSON(json: any): AuditEventResponse {
    return AuditEventResponseFromJSONTyped(json, false);
}

export function AuditEventResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEventResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'auditEventId': json['auditEventId'] === undefined ? undefined : json['auditEventId'] === null ? null : json['auditEventId'],
        'source': json['source'] == null ? undefined : AuditEventSourceFromJSON(json['source']),
        'graphEventId': json['graphEventId'] === undefined ? undefined : json['graphEventId'] === null ? null : json['graphEventId'],
        'eventDateTime': json['eventDateTime'] == null ? undefined : (new Date(json['eventDateTime'])),
        'category': json['category'] === undefined ? undefined : json['category'] === null ? null : json['category'],
        'activity': json['activity'] === undefined ? undefined : json['activity'] === null ? null : json['activity'],
        'result': json['result'] === undefined ? undefined : json['result'] === null ? null : json['result'],
        'resultReason': json['resultReason'] === undefined ? undefined : json['resultReason'] === null ? null : json['resultReason'],
        'initiatedById': json['initiatedById'] === undefined ? undefined : json['initiatedById'] === null ? null : json['initiatedById'],
        'initiatedByDisplayName': json['initiatedByDisplayName'] === undefined ? undefined : json['initiatedByDisplayName'] === null ? null : json['initiatedByDisplayName'],
        'initiatedByUpn': json['initiatedByUpn'] === undefined ? undefined : json['initiatedByUpn'] === null ? null : json['initiatedByUpn'],
        'targetId': json['targetId'] === undefined ? undefined : json['targetId'] === null ? null : json['targetId'],
        'targetDisplayName': json['targetDisplayName'] === undefined ? undefined : json['targetDisplayName'] === null ? null : json['targetDisplayName'],
        'targetUpn': json['targetUpn'] === undefined ? undefined : json['targetUpn'] === null ? null : json['targetUpn'],
        'ipAddress': json['ipAddress'] === undefined ? undefined : json['ipAddress'] === null ? null : json['ipAddress'],
        'correlationId': json['correlationId'] === undefined ? undefined : json['correlationId'] === null ? null : json['correlationId'],
        'locationCountryOrRegion': json['locationCountryOrRegion'] === undefined ? undefined : json['locationCountryOrRegion'] === null ? null : json['locationCountryOrRegion'],
        'rawJson': json['rawJson'] === undefined ? undefined : json['rawJson'] === null ? null : json['rawJson'],
        'targetUserType': json['targetUserType'] == null ? undefined : UserTypeFromJSON(json['targetUserType']),
        'targetInternalUserId': json['targetInternalUserId'] === undefined ? undefined : json['targetInternalUserId'] === null ? null : json['targetInternalUserId'],
    };
}

export function AuditEventResponseToJSON(json: any): AuditEventResponse {
    return AuditEventResponseToJSONTyped(json, false);
}

export function AuditEventResponseToJSONTyped(value?: AuditEventResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auditEventId': value['auditEventId'],
        'source': AuditEventSourceToJSON(value['source']),
        'graphEventId': value['graphEventId'],
        'eventDateTime': value['eventDateTime'] == null ? value['eventDateTime'] : value['eventDateTime'].toISOString(),
        'category': value['category'],
        'activity': value['activity'],
        'result': value['result'],
        'resultReason': value['resultReason'],
        'initiatedById': value['initiatedById'],
        'initiatedByDisplayName': value['initiatedByDisplayName'],
        'initiatedByUpn': value['initiatedByUpn'],
        'targetId': value['targetId'],
        'targetDisplayName': value['targetDisplayName'],
        'targetUpn': value['targetUpn'],
        'ipAddress': value['ipAddress'],
        'correlationId': value['correlationId'],
        'locationCountryOrRegion': value['locationCountryOrRegion'],
        'rawJson': value['rawJson'],
        'targetUserType': UserTypeToJSON(value['targetUserType']),
        'targetInternalUserId': value['targetInternalUserId'],
    };
}

